<mat-select
        placeholder="Select a state"
        [value]="value"
        [disabled]="disabled"
        (selectionChange)="handleChange($event.value)">
    <mat-option *ngFor="let state of states" [value]="state.abbreviation">
        {{state.name}} ({{state.abbreviation}})
    </mat-option>
</mat-select>
